/**
 * gets the move node element
 */
export function getMoveNodeEl(moveListEl: HTMLElement, line: number, move: number) {
  return moveListEl?.querySelector(`.node[data-node="${line}-${move}"]`) ?? undefined;
}
